import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import SaudeCaixaApi from '../../api/SaudeCaixaApi';
import AlertDialogSlide from '../share/AlertDialogSlide';

const styles = theme => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-end',
  },
  button: {
    margin: theme.spacing(1),
  },
});

class ToolbarExclusaoSelect extends React.Component {
  saudeCaixaApi = new SaudeCaixaApi();
  state = {
    openDialog: false,
  }

  handleClickExluir = () => {
    this.setState({ openDialog: true });
  }

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  }

  handleDialogConfirm = async () => {
    this.setState({ openDialog: false });
    this.props.handleClickToolBar();

    const arquivos = [];
    for (var i = 0; i < this.props.selectedRows.data.length; i++) {
      arquivos.push(this.props.displayData[this.props.selectedRows.data[i].index].data[0].props.children);
    }

    const result = await this.saudeCaixaApi.excluirArquivos(arquivos);
    this.props.setSelectedRows([]);
    this.props.onOperacaoFinalizada(result);
  };

  render () {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <div className={classes.root}>
          <Button
            variant='contained'
            className={classes.button}
            onClick={this.handleClickExluir}
            color='primary'
            size='small'
            title='Excluir'>
            <DeleteIcon className={classes.button} />
            Excluir
          </Button>
        </div>
        <AlertDialogSlide
          open={this.state.openDialog}
          handleClose={this.handleCloseDialog}
          handleClick={this.handleDialogConfirm}
          title={'Excluir Arquivo(s)...'}
          message={`${this.props.selectedRows.data.length}
                    arquivo(s) selecionado(s). Deseja excluir o(s) registro(s)?`} />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(ToolbarExclusaoSelect);
